import React, { useMemo } from 'react';
import DataTable from './DataTableFigma';

//AcceleratedDataTable will hold the DataTable in memory without rerendering
//except when rerender props is true. In this case it works as a regular DataTable.
//hiddenColumns is in the memo deps so toggling column visibility re-renders the table, and detailRequest so that a
//page can open an item's popup (TabOfDataTable.openDetails).
//columnWidths deliberately is NOT: resizing a column never needs a re-render at all. The grip
//writes the width onto the <table> as a CSS custom property, and DataTableFigma re-applies the
//whole set after each render, so a drag costs one style write instead of re-rendering every row.

const AcceleratedDataTable = (props) => {
  const content = (
    <DataTable
      itemList={props.itemList}
      orderBy={props.orderBy}
      orderDirection={props.orderDirection}
      changeOrderBy={props.changeOrderBy}
      type={props.type}
      getItemTypeFunction={props.getItemTypeFunction}
      selected={props.selected}
      selectable={props.selectable}
      thereIsNoSuchRowMessage={props.thereIsNoSuchRowMessage}
      popupEnabled={props.popupEnabled}
      redirectLinkOnInfo={props.redirectLinkOnInfo}
      ModalFeature={props.ModalFeature}
      afterClickOnCancel={props.afterClickOnCancel}
      hiddenColumns={props.hiddenColumns}
      resizableColumns={props.resizableColumns}
      columnWidths={props.columnWidths}
      onResizeColumn={props.onResizeColumn}
      detailRequest={props.detailRequest}
    />
  );
  if (props.rerender) return content;

  return useMemo(() => {
    return content;
  }, [props.hiddenColumns, props.detailRequest]);
};

export default AcceleratedDataTable;
